/**
 * Asset type metadata — single source of truth for type avatars + display
 * labels. Used across AssetList, AssetSlideOver, KPI tiles, and dashboard.
 */
export const ASSET_TYPES = [
  {value: "GPS_LOCK", label: "GPS Lock", code: "GPS", color: "bg-accent-500"},
  {value: "BT_LOCK", label: "BT Lock", code: "BT", color: "bg-info-600"},
  {value: "MOBI_TRACK", label: "Track Point", code: "MT", color: "bg-brand-600"},
  {value: "GT06_TRACKER", label: "GPS Tracker", code: "TRK", color: "bg-success-600"},
];

export const TYPE_META = Object.fromEntries(ASSET_TYPES.map((t) => [t.value, t]));

export function typeLabel(t) {
  return TYPE_META[t]?.label || t || "—";
}

export function typeCode(t) {
  return TYPE_META[t]?.code || "?";
}

export function typeColor(t) {
  return TYPE_META[t]?.color || "bg-ink-500";
}

export function statusToTone(status) {
  const s = (status || "").toUpperCase();
  if (s === "ACTIVE") return "success";
  if (s === "ASSIGNED") return "info";
  if (s === "SUSPENDED") return "danger";
  return "neutral";
}

/**
 * Body of POST /api/v1/{clientId}/assets for one device (the ApiRequest<ClientAssetRequest>
 * envelope). The server registers into this clientId and refuses one that differs from the
 * address, so callers pass the same clientId to both (the super admin console registers into the
 * client it is showing, everyone else into their own company).
 */
export function registerAssetBody({form, clientId, userId, requestId}) {
  return {
    requestId: String(requestId),
    clientId,
    userId,
    requestBody: {
      clientAsset: {
        name: form.name.trim(),
        description: (form.description || "").trim(),
        assetType: form.assetType,
        assetUnitId: form.assetUnitId.trim(),
        assetPassword: form.assetPassword ? btoa(form.assetPassword) : "",
        vehicleType: form.vehicleType || null,
        protocol: form.protocol || null,
      },
      countryCode: form.countryCode || null,
    },
  };
}
